module.exports = "/packs/media/images/older_granparents-10e2267fad850757c74e7629c6aee68b.jpeg";